import React from 'react'
import { M_Table } from 'src/M_Components'


const vessel = ({roles, tablesOrder = [], onTablesOrderUpdate}) => {
  return (
      <M_Table entityName={'vessel'} rolePermissions={roles} pageUrl={'Vessel'} tablesOrder={tablesOrder} onTablesOrderUpdate={onTablesOrderUpdate}/>

  )
}

export default vessel